import React, { FC } from "react";
import classNames from "classnames";
import { FeedbackTypes, RatingItemType } from "@app/pippa/models";
import "./rating.scss";

interface Props {
  isDisabled: boolean;
  rating: number;
  item: RatingItemType;
  feedbackType: string;
  onClickHandler: (props: RatingItemType) => void;
}

const getScoreRangeClass = (
  scoreNumber: number,
  feedbackType: string
): string => {
  if (feedbackType === FeedbackTypes.CSAT) {
    if (scoreNumber >= 1 && scoreNumber <= 2) return "score-detractor";
    if (scoreNumber === 3) return "score-passive";
    if (scoreNumber >= 4 && scoreNumber <= 5) return "score-promoter";
    return "";
  }

  if (scoreNumber >= 0 && scoreNumber <= 6) return "score-detractor";
  if (scoreNumber >= 7 && scoreNumber <= 8) return "score-passive";
  if (scoreNumber >= 9 && scoreNumber <= 10) return "score-promoter";
  return "";
};

const ScoresRating: FC<Props> = ({
  isDisabled,
  rating,
  item,
  feedbackType,
  onClickHandler,
}) => {
  return (
    <li className="scores-rating__item">
      <button
        className={classNames("scores-rating__button", {
          "selected-item": item.scoreNumber === rating,
          [getScoreRangeClass(item.scoreNumber, feedbackType)]:
            item.scoreNumber === rating,
        })}
        role="checkbox"
        aria-label={item.ariaLabel}
        aria-checked={item.scoreNumber === rating}
        onClick={() => onClickHandler(item)}
        disabled={isDisabled}
      >
        {item.scoreNumber}
      </button>
    </li>
  );
};

export default ScoresRating;
